module.exports = __webpack_public_path__ + "img/logo.6f93d1c6.png";